export default __webpack_public_path__ + "static/media/weather.9f728ce6.png";